import Resource from './base.resource'

export default class WoodsResource extends Resource
{
    constructor() {
        super('woods')
    }
}
